import React from 'react';

import { UserRolesType } from '../../@types';
import { useRoot } from '../../context/RootProvider';
import { ReactSuspense } from '../../designComponents';

export type DashboardProps = {
  text: string;
};

const roleToComponentMap: Record<
  UserRolesType,
  React.ComponentType<DashboardProps>
> = {
  ADMIN: React.lazy(() => import('./AdminDashboard')),
  CLIENT: React.lazy(() => import('./ClientDashboard')),
  TECHNICIAN: React.lazy(() => import('./TechnicianDashboard')),
  PRINTER: React.lazy(() => import('./PrinterDashboard')),
};
const getComponent = (userRole: UserRolesType) => {
  const allowedRoles = Object.keys(roleToComponentMap) as UserRolesType[];
  const isValidRole = allowedRoles.includes(userRole);

  return isValidRole
    ? roleToComponentMap[userRole]
    : React.lazy(() => import('../../designComponents/NotAllowded'));
};

const Dashbooard = () => {
  const { auth: user } = useRoot();
  const userRole = user?.role as UserRolesType;
  const Component = getComponent(userRole);

  return (
    <ReactSuspense>
      <Component text="asac" />
    </ReactSuspense>
  );
};

export default Dashbooard;
